import { InfoBox } from "../../../ui/molecules/infoBox"
import { formatDecimalTime, formatterDate, optionsFormatter, ServiceTypeNormoptions, ServiceTypeUnitOptions } from "../../../utils"
import { CustomerBillingWorksheetDTO } from "../dataService/dto"

interface Props {
    close: () => void
    customerBilling: CustomerBillingWorksheetDTO
}

export function SchedaCalcoloListViewPopup(props: Props) {
    return (
        <div className="px-6 py-5 flex flex-col gap-5">
            <div className="flex gap-5">
                <div className="flex-1">
                    <InfoBox
                        color="green"
                        content={[
                            { title: 'Anno', label: props.customerBilling.year },
                            { title: 'Data', label: formatterDate(props.customerBilling.createdAt) },
                            { title: 'Normativa', label: optionsFormatter(props.customerBilling.norm, ServiceTypeNormoptions) || '' },
                        ]}
                    />
                </div>
                <div className="flex-1">
                    <InfoBox
                        color="green"
                        content={[
                            { title: 'Totale Imponibile', label: `€${props.customerBilling.totalTaxableFee}` },
                            { title: 'Totale Iva', label: `€${props.customerBilling.totalIva}` },
                            { title: 'Importo Totale', label: `€${props.customerBilling.totalFee}` }
                        ]}
                    />
                </div>
            </div>
            <div className="border-t border-neutral-200" />
            <div className="flex flex-col gap-3">
                <div className="flex items-center gap-2">
                    <span className="w-1 h-5 rounded-full bg-brandPrimary-500 inline-block" />
                    <span className="text-sm font-semibold uppercase tracking-wide text-brandPrimary-600">
                        Elenco Servizi
                    </span>
                </div>
                <InfoBox
                    color="green"
                    table={{
                        title: null,
                        headers: ['Codice', 'Descrizione', 'Tipo Unità', 'Quantità', 'Imponibile', 'Iva', 'Importo'],
                        values: props.customerBilling.services.map(s => [
                            `[${s.serviceTypeCode}]`,
                            s.serviceTypeDescription,
                            optionsFormatter(s.unitType, ServiceTypeUnitOptions) || '',
                            String(s.unitType === 'ORE' ? formatDecimalTime(s.unitEmployed) : s.unitEmployed),
                            "€" + String(s.taxableFee),
                            "€" + String(s.iva),
                            "€" + String(s.totalFee)
                        ])
                    }}
                />
            </div>
            <div className="border-t border-neutral-200" />
            <div className="flex flex-col gap-3">
                <div className="flex items-center gap-2">
                    <span className="w-1 h-5 rounded-full bg-orange-400 inline-block" />
                    <span className="text-sm font-semibold uppercase tracking-wide text-orange-600">
                        Elenco Spese Aggiuntive
                    </span>
                </div>
                <InfoBox
                    color="orange"
                    table={{
                        title: null,
                        headers: ['Codice', 'Descrizione', 'Imponibile', 'Iva', 'Importo'],
                        values: props.customerBilling.additionalExpenses.map(a => [
                            `[${a.serviceTypeCode}]`,
                            a.serviceTypeDescription,
                            "€" + String(a.taxableFee),
                            "€" + String(a.iva),
                            "€" + String(a.totalFee)
                        ])
                    }}
                />
            </div>
        </div>
    )
}